'use client'

import { useEffect, useState } from 'react'
import { useTranslations } from 'next-intl'
import { Link } from '@/navigation'
import { OPEN_BANNER_EVENT, getStoredConsent, saveConsent, type ConsentChoice } from '@/lib/consent'

export default function CookieBanner() {
  const t = useTranslations('Cookies')
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Só decide depois de montar, para o HTML do servidor e o primeiro render do cliente serem idênticos
    setVisible(getStoredConsent() === null)
    const reopen = () => setVisible(true)
    window.addEventListener(OPEN_BANNER_EVENT, reopen)
    return () => window.removeEventListener(OPEN_BANNER_EVENT, reopen)
  }, [])

  function choose(choice: ConsentChoice) {
    saveConsent(choice)
    setVisible(false)
  }

  if (!visible) return null

  return (
    <section
      aria-label={t('ariaLabel')}
      className="fixed inset-x-4 bottom-4 z-50 mx-auto max-w-2xl rounded-2xl border border-white/15 bg-[#151515] p-5 text-[#f4f1e8] shadow-2xl"
    >
      <p className="text-sm leading-6 text-[#f4f1e8]/90">
        {t('text')}{' '}
        <Link href="/privacidade" className="font-semibold text-[#d8f36b] underline underline-offset-4">
          {t('privacyLink')}
        </Link>
      </p>
      <div className="mt-4 flex flex-wrap gap-3">
        <button
          type="button"
          onClick={() => choose('granted')}
          className="rounded-full bg-[#d8f36b] px-5 py-2.5 text-sm font-semibold text-[#151515] transition hover:bg-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#d8f36b]"
        >
          {t('accept')}
        </button>
        <button
          type="button"
          onClick={() => choose('denied')}
          className="rounded-full border border-white/30 px-5 py-2.5 text-sm font-semibold text-[#f4f1e8] transition hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#d8f36b]"
        >
          {t('reject')}
        </button>
      </div>
    </section>
  )
}
